<template>
  <div>
    <div class="gradient text-secondary pa-2">
      <h3>{{ runner.nom }} {{ runner.prenom }} #{{ runner.dossard }}</h3>
      <h5>{{ runner.course }}</h5>
    </div>

    <div class="d-flex justify-space-between my-2 px-2">
      <div>
        Temps cumulé: <b>{{ get_temps_cumul(runner) }}</b>
      </div>
    </div>
    <v-divider class="my-2"></v-divider>
    <h3 class="font-weight-bold mb-2">Ses résultats</h3>

    <div v-for="result in runner.loop_results" :key="result.loop">
      <div class="d-flex ga-2">
        <v-chip label class="gradient text-secondary">Boucle {{ loop_with_offset(result.loop_id) }}</v-chip>
        <div>
          <strong>{{ result.temps }}</strong>
          <div class="text-caption">Clt {{ result.classement }} <b>|</b> Clt Sexe. {{ result.classement_sexe }}{{
            runner.sexe }} <b>|</b> Clt Cat. {{ result.classement_categorie }}{{ runner.categorie }}</div>
        </div>
      </div>
      <v-divider class="my-2"></v-divider>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["runner"],
  methods: {
    loop_with_offset(loop_id) {
      if (this.$store.state.selected_challenge === "12_heures" || this.$store.state.selected_challenge === "24_heures") {
        return loop_id;
      }
      return loop_id - 1;
    },
    get_temps_cumul(runner) {
      let duration = moment.duration(runner.temps_cumul);
      let res_duration = "";
      if (duration.days() === 0) {
        res_duration = moment.utc(runner.temps_cumul).format("HH:mm:ss");
      } else {
        res_duration = `${duration.days()}j ${moment.utc(runner.temps_cumul).format("HH:mm:ss")}`;
      }
      return res_duration;
    },
  },
};
</script>

<style lang="scss" scoped></style>